var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptocom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_89",
    "data-name": 89,
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABz0lEQVR4Xt2a200DMRBFUwIlUEJKSAmbCP7phHRICZRACYYVEojjkPW8bM8e6fw49r3jj40UZQ+HXlxKEZkeXshqCpZyqgb3dilH1o5nKa/VoNGunVPAwXo7DA4y2q6wfBbDuZT3qnQ2z18zhsCi2XWF4Vl0gaHZNJHhmd/yXN54rXYYllUVDMmuCB7ei83w4F5sgoe83YL7vb1L1K86Lczx8cqaX+rNNr1grtWbPJdjtdGiN8y3uJQHxvsWRMEeixXcoDUa9mmNDw2EvTo/fAN7sj7D7Nf4Az/Q2Bv2a3QLGwXnkOoSsjoKzqGxWtA4Cs6hsVqQOhrOI7VakJoeXkhqenghqenhhaSmhxeSmh5eSGp6eCGpo+E8UqsFjaPgHBqrBY2j4BwaXYJGwTmkugWt9ob9GmPCOsF+ja5hq71gr9b40ADYp7WCGyxGwR6LFd5veXrDfItLeWT8N9xo1QvmWv2X9Y9DbvZQC3M8XMoLa/7CA95uwf3eNsFDe7EZHtyLIng4uyoYklU1+3hR8p3XksHAbLrA0Cy6wvDZDSHDd4L5mW+BpbPYFZaPdhgcpLdTEPUr8r5XjjEe77dNb/lUTqydEw5uNT280Jad+ARTN/5LEYj5RgAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocom);
export default __webpack_public_path__ + "static/media/cryptocom.9a25c81565286bf7014712d986e42b8d.svg";
export { ForwardRef as ReactComponent };